export default __webpack_public_path__ + "static/media/mecht.ai_scheme.bc437e37.png";